import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { Promotions } from "../../Objects/Promotion/Promotions"
import { promotionsMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useGetPromotions = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetPromotions = async (onSuccess: any, database: string = API_ROUTES.PROMOTION.GET_ALL) => {
    enableLoad()
    try {
      const response = await GetRequest<Promotions[]>(database)

      if (response.success) {
        const temp = response.data?.map((ss) => new Promotions(ss)) ?? []

        promotionsMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetPromotions,
  }
}
